
import Vue from "vue";

export default Vue.extend({
  name: "Header",
  data() {
    return {
      model: 0,
      bgs: [
        require("@/assets/imgs/hero.png"),
        require("@/assets/imgs/hero.png"),
        require("@/assets/imgs/hero.png"),
      ],
    };
  },
});
